import type { AttachCallOffAttachmentPayload } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import {
  zodAttachCallOffAttachmentEndpointSchema,
  zodAttachCallOffAttachmentPayloadSchema,
} from './validations';

/**
 * Confirms a staged file upload and permanently attaches it to a call-off.
 * Call this after uploading a file via the signed URL flow.
 *
 * @param callOffId - The ID of the call-off to attach the file to.
 * @param payload - The attachment payload containing file ID, name and MIME type.
 * @param options - Optional request options (e.g., abort signal).
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Call-Off/operation/attach_attachment_calloffs__calloff_id__attachments_put
 */
export const attachCallOffAttachment = async (
  callOffId: UUID,
  payload: AttachCallOffAttachmentPayload,
  options?: KyRequestOptions,
) => {
  const response = await vestigasApi
    .post(ENDPOINT.CALL_OFF_ATTACHMENT.ADD(callOffId), {
      json: payload,
      validate: {
        body: zodAttachCallOffAttachmentPayloadSchema,
        pathSegments: zodAttachCallOffAttachmentEndpointSchema,
      },
      ...options,
    })
    .json<void>();

  return response;
};
